import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-user-editor',
  templateUrl: './user-editor.component.html',
  styleUrls: ['./user-editor.component.scss']
})
export class UserEditorComponent implements OnInit {
    @Input() userFormInput: FormGroup;
    @Input() existing = false;

    get userForm() { return this.userFormInput.controls; }

    constructor() { }

    ngOnInit(): void {
    }

}
